import { IPFS_GATEWAY } from './babydogeswap'
import { Team } from './types'

export const teams: Team[] = [
  {
    id: 1,
    name: 'Bulldogs',
    description: '',
    images: {
      lg: 'bulldogs-lg.webp',
      md: 'bulldogs-md.webp',
      sm: 'bulldogs-sm.webp',
      alt: 'bulldogs-alt.webp',
      ipfs: `${IPFS_GATEWAY}/QmXqR7Un7tKtmoTn3moS8dPtGJYuoLnC8kg2wNGXvAuPNa?filename=bulldogs.webp`
    },
    background: 'bulldogs-bg.svg',
    textColor: '#191326',
    users: 0,
    points: 0
  },
  {
    id: 2,
    name: 'Huskies',
    description: '',
    images: {
      lg: 'huskies-lg.webp',
      md: 'huskies-md.webp',
      sm: 'huskies-sm.webp',
      alt: 'huskies-alt.webp',
      ipfs: `${IPFS_GATEWAY}/QmboPX9VhtZegEqhGHRbJva23Uv9KGZR9x9NJJX4VZ59kG?filename=huskies.webp`
    },
    background: 'huskies-bg.svg',
    textColor: '#FFFFFF',
    users: 0,
    points: 0
  },
  {
    id: 3,
    name: 'Shepherds',
    description: '',
    images: {
      lg: 'shepherds-lg.webp',
      md: 'shepherds-md.webp',
      sm: 'shepherds-sm.webp',
      alt: 'shepherds-alt.webp',
      ipfs: `${IPFS_GATEWAY}/QmVCbTdE4dAyoVnJa8SV9Xjok7hT5MGqvuCBm1YXMkCLBX?filename=shepherds.webp`
    },
    background: 'shepherds-bg.svg',
    textColor: '#191326',
    users: 0,
    points: 0
  }
]
